module.exports = __webpack_public_path__ + "img/iconnoti.6b4de9ec.svg";